export const EASE_PREMIUM = [0.16, 1, 0.3, 1] as const;
export const EASE_PREMIUM_IN = [0.7, 0, 0.84, 0] as const;

export const EASE_FADE = [0.42, 0, 0.58, 1] as const;

export const RISE_Y = 12;

export const MOTION = {
  enter: 0.36,
  stagger: 0.06,
  stageDelay: 0.06,
  exit: 0.24,
  layout: 0.32,
  pageEnter: 0.5,
  pageExit: 0.22,
  reveal: 0.5,
  crossfade: 0.22,
  track: 0.9,
  meter: 0.5,
  pulse: 1.9,
  pulseGap: 0.4,
  micro: 0.2,
  reducedEnter: 0.15,
  reducedPage: 0.1,
} as const;
